import { Injectable } from '@angular/core';
import { createPopup } from '@typeform/embed';
import { CustomerStoreService } from '../../core/services/customer-store.service';
import { AppConfig } from '../../core/services/app-config.service';
import { first } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TypeformService {
  constructor(private config: AppConfig, private customerStoreService: CustomerStoreService) {}

  private isOnboardingOpen = false;
  readonly removeAccountSubmit: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  public showReportBtApiIssue(btApiAccountId: string, billerId: string, liabilityTitle?: string) {
    createPopup(this.config.config.typeformConfig.formIds.btApi, {
      hidden: {
        account_id: btApiAccountId,
        biller_id: billerId,
        environment_id: this.config.config.typeformConfig.environmentId,
        email_address: this.customerStoreService.state.email,
        customer_id: this.customerStoreService.state.customerId,
        liability_title: liabilityTitle,
      },
      size: 70,
    }).open();
  }

  public showOnboardingQuestionnaire() {
    if (this.config.config.typeformConfig?.enabled && !this.isOnboardingOpen) {
      this.isOnboardingOpen = true;
      this.customerStoreService.state$.pipe(first((state) => !!state)).subscribe(() => {
        createPopup(this.config.config.typeformConfig.formIds.onboardingQuestionnaire, {
          hidden: {
            customer_id: this.customerStoreService.state.customerId,
            environment_id: this.config.config.typeformConfig.environmentId,
          },
          size: 100,
          autoClose: 3000,
          onReady: () => {
            this.isOnboardingOpen = false;
          },
        }).open();
      });
    }
  }

  public showRemoveAccountQuestionnaire() {
    if (this.config.config.typeformConfig?.enabled) {
      createPopup(this.config.config.typeformConfig.formIds.removeAccountQuestionnaire, {
        hidden: {
          customer_id: this.customerStoreService.state.customerId,
          environment_id: this.config.config.typeformConfig.environmentId,
        },
        size: 70,
        onSubmit: ({ responseId }) => {
          this.removeAccountSubmit.next(responseId);
        },
      }).open();
    }
  }
}
